function isActiveLicense(license) {
  return Boolean(license) && !(license.expires < Date.now());
}

export default function hasActiveAtlasLicense(user) {
  if (!user) return false;
  return isActiveLicense(user.atlasv2) || isActiveLicense(user.atlasv3);
}
